import { useEffect } from "react";
import { io } from "socket.io-client";

import { useAccount, useIsAuthenticated } from "@azure/msal-react";
import { msalInstance } from "msalClient";

export let socket = null;

export const logoutUser = async () => {
  const azureId =
    msalInstance.getActiveAccount()?.idTokenClaims?.sub ||
    msalInstance.getAllAccounts()?.[0]?.idTokenClaims?.sub ||
    sessionStorage.getItem("azureId") ||
    localStorage.getItem("azureId");

  if (socket?.connected) {
    await new Promise((resolve) => {
      socket.emit("logout", { userid: azureId, time: new Date() }, resolve);
      setTimeout(resolve, 1000);
    });
  }

  sessionStorage.clear();
  localStorage.clear();

  await msalInstance.logoutRedirect({
    postLogoutRedirectUri:
      typeof window !== "undefined" ? window.location.origin : undefined,
  });
};

export const useSocket = () => {
  const isAuthenticated = useIsAuthenticated();
  const account = msalInstance.getAllAccounts()?.[0];
  useEffect(() => {
    if (!isAuthenticated || !account) return;
    if (socket) return;

    socket = io(`${process.env.REACT_APP_SOCKETURL}`, {
      path: process.env.REACT_APP_SOCKET_PATH || "/notify/socket.io",
    });
    const emitJoin = () => {
      const socketAzureID = account.idTokenClaims?.sub;
      if (socketAzureID) {
        socket.emit("join", { userid: socketAzureID });
      }
    };

    socket.on("connect", emitJoin);

    // If already connected (e.g. fast connection before listener registered)
    if (socket.connected) {
      emitJoin();
    }

    socket.on("logoutfromcurrentsite", logoutUser);

    return () => {
      if (socket) {
        socket.off("connect", emitJoin);
        socket.off("logoutfromcurrentsite", logoutUser);
        socket.disconnect();
        socket = null;
      }
    };
  }, [account, isAuthenticated]);

  return socket;
};
